import { Injectable, inject } from '@angular/core';
import { switchMap, map, catchError, of, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { AuthActions, AuthApiActions } from './auth.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthError } from '../interfaces/auth.interface';
import { Router } from '@angular/router';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);
  private router = inject(Router);

  private mapLoginError(error: HttpErrorResponse): AuthError {
    if (error.status === 401) {
      return 'INVALID_CREDENTIALS';
    }

    if (error.status === 0) {
      return 'NETWORK_ERROR';
    }

    return 'UNKNOWN';
  }

  public login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),

      switchMap((payload) =>
        this.authService.login(payload.email, payload.password).pipe(
          map((response) => AuthApiActions.loginSuccess({ user: response.data.accessToken })),
          tap(() => {
            this.router.navigate(['/dashboard']);
          }),
          catchError((error: HttpErrorResponse) =>
            of(
              AuthApiActions.loginFailure({
                error: this.mapLoginError(error),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),

      switchMap(() =>
        this.authService.logout().pipe(
          map(() => AuthApiActions.logoutSuccess()),

          catchError((error) =>
            of(
              AuthApiActions.logoutFailure({
                error: error.message,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public signup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.signup),

      switchMap((payload) =>
        this.authService.signUp(payload).pipe(
          map((response) => AuthApiActions.signupSuccess({ user: response.data.accessToken })),

          catchError((error) =>
            of(
              AuthApiActions.signupFailure({
                error: error.message,
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
